var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21849 7.97827C3.49315 8.25311 3.93828 8.25293 4.21275 7.97827L7.2252 4.96582C7.49986 4.69135 7.49986 4.24603 7.2252 3.97156C6.95073 3.6969 6.5056 3.6969 6.23094 3.97156L4.41875 5.78375V0.703125C4.41875 0.314758 4.10381 0 3.71562 0C3.32725 0 3.0125 0.314758 3.0125 0.703125V5.78375L1.2003 3.97156C0.925644 3.6969 0.480514 3.6969 0.205856 3.97156C-0.0686188 4.24603 -0.0686188 4.69135 0.205856 4.96582L3.21849 7.97827Z",
    fill: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72821 9.79102H0.703125C0.314941 9.79102 0 10.1058 0 10.4941C0 10.8823 0.314941 11.1973 0.703125 11.1973H6.72821C7.11639 11.1973 7.43134 10.8823 7.43134 10.4941C7.43134 10.1058 7.11658 9.79102 6.72821 9.79102Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownload);
export default __webpack_public_path__ + "static/media/arrow-download.73ea6f39b2106c55ce09f617ee23fd85.svg";
export { ForwardRef as ReactComponent };